function getResults(defaultPageNumber = null) {
  const paginateElem = $("#js-paginate-editorial-hub").attr("href");
  const splitHref = paginateElem.split("?");
  const splitPageNumber = splitHref[splitHref.length - 1].split("=");
  const pageNumber = parseInt(splitPageNumber[splitPageNumber.length - 1]);

  fetch(`/pages/editorial-api?page=${defaultPageNumber || pageNumber + 1}`, {
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((res) => {
      return res.text();
    })
    .then((html) => {
      // Revert quotation marks from unicode
      const results = html.replace(/&quot;/g, '"');
      const parsedResults = JSON.parse(results);

      const blogs = $("#formatted-results").data().blogs;
      $("#js-paginate-editorial-hub").attr(
        "href",
        `/editorial-hub?page=${pageNumber + 1}`
      );
      return $("#formatted-results").append(`
        ${parsedResults
          .map((result) => {
            return `
            <article class="article-item--default">
              <img class="article-item__image lazyload" data-src="${
                result.image && result.image.src
              }" alt="${result.image && result.image.alt}"/>
              <div class="article-item__content">
                <div>
                  <p>General</p>
                  <h3>${result.title}</h3>
                </div>
                <a href="/blogs/${
                  blogs.find((blog) => blog.id === result.blog_id) &&
                  blogs.find((blog) => blog.id === result.blog_id).name
                }/${result.handle}">Read More</a>
              </div>
            </article>
          `;
          })
          .join(" ")}
      `);
    })
    // Run another fetch for the following page to see if there are any more articles.
    // If not then hide the 'show more' button.
    .then(() => {
      fetch(`/pages/editorial-api?page=${pageNumber + 1}`, {
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => {
          return res.text();
        })
        .then((html) => {
          const nextResults = html.replace(/&quot;/g, '"');
          const parsedNextResults = JSON.parse(nextResults);

          if (parsedNextResults.length < 1) {
            $("#js-paginate-editorial-hub").hide();
          }
        });
    });
}

if ($("#formatted-results").length > 0) {
  getResults(1);
}

if ($("#js-paginate-editorial-hub")) {
  $("#js-paginate-editorial-hub").on("click", function (e) {
    e.preventDefault();
    getResults();
  });
}

// Handle the hero unit / nav for other blog pages
if ($(".js-blog-hero")) {
  $.get("/pages/editorial-hub").done(function (res) {
    $("#blog-loader").hide();
    $(".js-blog-hero").html($(res).find(".js-featured-article-hero").html());
    $(".js-category-block").html($(res).find(".js-editorial-nav").html());
    $(".hero").slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 5000,
      draggable: true,
    });

    $(".js-editorial-category").each((i, element) => {
      if (window.location.href.includes($(element).attr("href"))) {
        $(element).addClass("is-active");
      }
    });
  });
}
